import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { vendorNotificationEmailApiService } from '../service/api/vendorNotificationEmailApiService';
import {
  VendorNotificationEmailCreateRequest,
  VendorNotificationEmailRow,
} from '../type/vendorNotificationEmailType';

export const VENDOR_NOTIFICATION_EMAIL_QUERY_KEYS = {
  all: ['vendor-notification-email'] as const,
  list: (userId: number | null) =>
    [...VENDOR_NOTIFICATION_EMAIL_QUERY_KEYS.all, 'list', userId ?? 'none'] as const,
};

export const useVendorNotificationEmailList = (userId: number | null) => {
  return useQuery({
    queryKey: VENDOR_NOTIFICATION_EMAIL_QUERY_KEYS.list(userId),
    queryFn: () =>
      vendorNotificationEmailApiService.fetchList({
        user_id: userId ?? undefined,
        page: 1,
        page_size: 100,
      }),
    enabled: !!userId,
    staleTime: 60 * 1000,
  });
};

export const useCreateVendorNotificationEmail = () => {
  const queryClient = useQueryClient();
  return useMutation<VendorNotificationEmailRow, unknown, VendorNotificationEmailCreateRequest>({
    mutationFn: body => vendorNotificationEmailApiService.createEmail(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VENDOR_NOTIFICATION_EMAIL_QUERY_KEYS.all });
    },
  });
};

export const useDeleteVendorNotificationEmail = () => {
  const queryClient = useQueryClient();
  return useMutation<void, unknown, number>({
    mutationFn: id => vendorNotificationEmailApiService.deleteEmail(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VENDOR_NOTIFICATION_EMAIL_QUERY_KEYS.all });
    },
  });
};
